import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { GetEmployeePayload } from "../../payload/GetEmployee/GetEmployeePayload";

const getEmployeeFetch = (state: EmployeesState, action: PayloadAction<GetEmployeePayload>) => {
    state.isLoading = true;
}

export default getEmployeeFetch;